import api from '../../utils/api'

export const state = {
  userPreferences: {},
}

export const mutations = {
  SET_USE_RPREFERENCES(state, userPreferences) {
    state.userPreferences = userPreferences || {}
  },
}
export const actions = {
  async handleGetUserPreferences({ commit }, userId) {
    const { data } = await api.get(`/user-preferences/${userId}`);
    const {userPreferences} = data || {}
    commit('SET_USE_RPREFERENCES', userPreferences || {})
    return data
  },
  async handleCreateUserPreferences({ commit }, payload) {
    return await api.post('/user-preferences', payload);
  },
  async handleChangUserPreferences({ commit }, payload) {
    return await api.put(`/user-preferences/${payload._id}`, payload);
  },
  async handleUpdateTabSummaryRiskOpen({ commit }, body) {
    await api.put(`/user-preferences/${body._id}/tab-summary-risk-open`, body);
  },
}

export const getters = {
  userPreferences: state => state.userPreferences,
}
